import { z } from "zod";
import type {
    DateAgnosticTime} from "./date-agnostic-time";
import {
    dateAgnosticTimeZodSchema,
} from "./date-agnostic-time";

type DateAgnosticTimeRange = { start: DateAgnosticTime; end: DateAgnosticTime };
const dateAgnosticTimeRangeZodSchema: z.ZodSchema<DateAgnosticTimeRange> =
    z.object({
        start: dateAgnosticTimeZodSchema,
        end: dateAgnosticTimeZodSchema,
    });

const dateAgnosticTimeRangeFactory = (
    start: DateAgnosticTime | undefined,
    end: DateAgnosticTime | undefined
): DateAgnosticTimeRange | undefined => {
    if (!start || !end) return undefined;
    if (start.hour > end.hour) {
        // eslint-disable-next-line no-console
        console.warn(new Error("start cannot be after end"));
        return undefined;
    }
    if (start.hour === end.hour && start.minute > end.minute) {
        // eslint-disable-next-line no-console
        console.warn(new Error("start cannot be after end"));
        return undefined;
    }
    return { start, end };
};

export type { DateAgnosticTimeRange };
export { dateAgnosticTimeRangeFactory, dateAgnosticTimeRangeZodSchema };
